// 导入所有模块
import * as User from './module/user.js'
import * as Stat from './module/stat.js'
import * as Operator from './module/operator.js'
import * as Account from './module/account.js'
import * as OrgStation from './module/org-station.js'
import * as Device from './module/device.js'
import * as Order from './module/order.js'
import * as Card from './module/card.js'
import * as OperatorModel from './module/operator-model.js'
import * as ServiceCharge from './module/service-charge.js'
import * as Message from './module/message.js'
import * as Feedback from './module/feedback.js'
import * as Marketing from './module/marketing.js'
import * as Common from './module/common.js'
import * as Team from './module/team.js'

import Api from './api.js'

const Module = {
	...User, // 用户 | 用户规则 | 管理员 | 权限
	...Stat, // 统计 | 地图统计 | 分账账户统计 | 对账单
	...Operator, // 运营商 | 子运营商 | 运营商配置 | 权益包 | 白名单
	...Account, // 平台收款账户 | 分账账户 | 账户划转 | 虚拟账户 | 分账对账单
	...OrgStation, // 片区 | 有序充电 | 充电站 | 运营商设置
	...Device, // 设备 | 设备配置 | 设备任务 | 设备型号 | redis-worker | 电池 | 道闸 | 摄像头 | 设备白名单 | 车辆
	...Order, // 充电订单 | 充值订单 | 占位订单 | 追款订单 | 换电柜订单 | 分账订单 | 金额变动 | 分账流水
	...Card, // 实体卡 | 虚拟卡 | 卡充值
	...OperatorModel, // 计费模板 | 分账模板 | 卡片模板
	...ServiceCharge, // 服务费相关
	...Message, // 系统公告 | 常见问题 | 告警 | 错误日志
	...Feedback, // 反馈工单 | 退款
	...Marketing, // 营销账户 | 广告 | 保险
	...Common, // 公共 | 黑名单 | 工人 | 导出 | 微信平台 | 通知
	...Team, // 组织 | 组织成员
}

Object.assign(Module, Api)   // 配置轨命名空间（Core.Api.Team.list 等存量调用面）并入

export default Module
